// src/hooks/order/useOrderInitialization.ts
// Hook para inicializar datos antiguos del pedido en modo edit

import { useState, useEffect } from 'react'
import type { OrderData } from '../../types/orderFormTypes'

interface OldDataOrder {
  status?: string
  customer_note?: string
  lineItems?: any[]
  transaction_id?: string
}

interface UseOrderInitializationProps {
  initialData?: OrderData
  mode: 'view' | 'edit' | 'create'
}

interface UseOrderInitializationReturn {
  oldDataOrder: OldDataOrder
}

export function useOrderInitialization({
  initialData,
  mode
}: UseOrderInitializationProps): UseOrderInitializationReturn {
  const [oldDataOrder, setOldDataOrder] = useState<OldDataOrder>({})

  // Inicializar oldDataOrder en modo edit
  useEffect(() => {
    if (mode === 'edit' && initialData) {
      const oldData: OldDataOrder = {
        status: initialData.status,
        customer_note: initialData.extraDetails?.customer_note?.trim() || '',
        lineItems: initialData.lineItems || [],
        transaction_id: initialData.extraDetails?.transaction_id || ''
      }
      setOldDataOrder(oldData)
    }
  }, [mode, initialData])

  return {
    oldDataOrder
  }
}

